export default __webpack_public_path__ + "static/media/console.733caba2.svg";